import { createRef, RefObject, useEffect, useRef, useState } from "react";

import { Icon } from "@newsela/angelou";

import { FilterSection } from "@/search/Langston/FilterPanel/FilterSection";
import useGetUserProperties from "@/users/v3/useGetUserProperties";
import { LangstonParameterSchema } from "@/search/Langston/LangstonParameterSchema";
import { InstructionalFeatureCheckbox } from "./InstructionalFeatureCheckbox";
import { fieldsetCss, legendCss } from "./InstructionalFeature.styles";
import { InstructionFeatureValuesEnum } from "./InstructionalFeature.constants";

const instructionalFeatureOptions =
  LangstonParameterSchema.instructional_features.values;

export const InstructionalFeature = () => {
  const { isTeacher, activeELALicense, canSeeFormative } =
    useGetUserProperties();

  const checkboxRefs = useRef(
    instructionalFeatureOptions.map(() => createRef<HTMLInputElement>()),
  );

  const [isDomReady, setIsDomReady] = useState(false);

  useEffect(() => {
    setIsDomReady(true);
  }, []);

  const canSeePowerWords = activeELALicense;
  const canSeeDecodables = isTeacher && activeELALicense;

  return (
    <FilterSection defaultCollapsed={false} title="Instructional feature">
      <fieldset css={fieldsetCss}>
        <legend css={legendCss}>Filter content by instructional feature</legend>
        {instructionalFeatureOptions.map((option, index) => {
          const currentRef = checkboxRefs?.current?.[
            index
          ] as RefObject<HTMLInputElement>;
          const targetElement = currentRef?.current?.nextSibling
            ?.nextSibling as Element;

          const paramName =
            option?.paramName ||
            LangstonParameterSchema.instructional_features.key;

          if (
            option.value === InstructionFeatureValuesEnum.decodable &&
            !canSeeDecodables
          )
            return null;

          if (
            option.value === InstructionFeatureValuesEnum.power_words &&
            !canSeePowerWords
          )
            return null;

          if (
            option.value === InstructionFeatureValuesEnum.formative &&
            !canSeeFormative
          )
            return null;

          return (
            <InstructionalFeatureCheckbox
              key={index}
              paramName={paramName}
              option={option}
              currentRef={currentRef}
              isDomReady={isDomReady}
              targetElement={targetElement}
              IconComponent={<Icon SvgComponent={option.SvgComponent} />}
            />
          );
        })}
      </fieldset>
    </FilterSection>
  );
};
